import React from "react";
import { BsEye } from "react-icons/bs";
import { CiTrophy } from "react-icons/ci";
import { motion } from "framer-motion";

const Vision = () => {
  return (
    <section className="flex flex-col items-center justify-between min-h-full  md:flex-row md:justify-center md:items-center w-full bg-slate-50 py-24">
      <motion.div
        initial={{ opacity: 0, x: -30 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ type: "spring", duration: 1.5 }}
        className="flex flex-col justify-center w-full md:w-400 px-8"
      >
        <h1 className="font-bold text-2xl tracking-wider mb-8">
          Welcome To{" "}
          <p className="font-bold text-5xl text-maroon">Emaan Institute</p>
        </h1>
        <p className="font-normal  w-900 text-justify">
        EMAAN INSTITUTE OF MANAGEMENT & SCIENCES (EIMS) has been established through a Legislative Act of the Sindh Assembly (Sindh Act No: XXXV of 2018) and is approved and recognized by the Higher Education Commission (HEC) as Degree Awarding Institute in 2019. 
Emaan Institute Of Management & Sciences has been established for creating leaders and developing the best professionals in every arena of life. It is our motto to impart the best quality education to the people of Pakistan. 
        </p>
      </motion.div>
      <div className=" hidden md:block bg-maroon h-96 w-px rounded-full "></div>

      <motion.div
        initial={{ opacity: 0, x: 30 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ type: "spring", duration: 1.5 }}
        className="flex flex-col w-full md:w-400 px-8 space-y-8"
      >
        <div className="flex flex-col">
          <div className="flex items-center space-x-6  text-maroon">
            <BsEye className="w-14 h-14" />
            <h1 className="font-bold text-3xl">OUR VISION</h1>
          </div>
          <p className="font-normal text-justify">
          “To be a leading degree awarding Institute 
          through innovation, Research, Creativity,
           and Leadership.”
          </p>
        </div>

        <div className="flex flex-col">
          <div className="flex items-center space-x-6  text-maroon">
            <CiTrophy className="w-14 h-14" />
            <h1 className="font-bold text-3xl">OUR MISSION</h1>
          </div>
          <p className="font-normal text-justify">
          To empower students with knowledge, 
          skills and ethical values to excel in their 
          dynamic fields by providing transformative educational
           experience that foster intellectual growth, innovative and 
           critical thinking through research and diligent academic programs.
          </p>
        </div>
      </motion.div>
    </section>
  );
};

export default Vision;
